import { Stack } from '@mui/material'
import { MarkdownEditor } from '@ui/forms'

interface Props {
  elementGuid?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FormFields = ({ elementGuid }: Props) => {
  return (
    <Stack direction="column" spacing={2}>
      <MarkdownEditor
        name="preamble"
        label="Vorbemerkungen"
        placeholder="Vorbemerkungen (mehrere Zeilen möglich)"
        allowHorizontalResize={false}
      />
    </Stack>
  )
}

export default FormFields
